import { SliceZone } from '@prismicio/react';

import { useProductCategoryDetailsQuery } from '@sdk/gqlTypes/generatedHooks';

import { isMinimalist as isMinimalistType } from '@lib/Configurator3D/ModelFactory';

import { ProductDetailsFragment } from '@sdk/gqlTypes/generatedOperations';
import { PrismicProductPageQuery } from '@prismic/gqlTypes/prismicOperations';

import { ProductReviews } from '@components/organisms/ProductReviews';

import { ReactElement } from 'react';

import { useRouter } from 'next/router';
import { localeToSaleorQuery } from '@utils/regions';
import { components } from './Slices';

import OtherProducts from './OtherProducts';

interface Props {
  product: ProductDetailsFragment;
  productDetails: PrismicProductPageQuery['product'] | null;
}

export function ProductConfiguratorBody({
  product,
  productDetails,
}: Props): ReactElement {
  const { locale } = useRouter();

  const { data: dataCategory } = useProductCategoryDetailsQuery({
    variables: {
      id: product.category.id,
      ...localeToSaleorQuery(locale),
    },
  });

  const { category: saleorCategory } = dataCategory || {};

  const labeledIcons = productDetails?.body?.filter(
    (slice) => slice.type === 'labeled_icons'
  );

  const inspiration = productDetails?.body.filter(
    (slice) => slice.type === 'inspiration'
  );

  const features = productDetails?.body.filter(
    (slice) => slice.type === 'product_features'
  );

  const details = productDetails?.body.filter(
    (slice) => slice.type === 'product_details'
  );

  const colorSample = productDetails?.body.filter(
    (slice) => slice.type === 'color_sample'
  );

  const instagramPosts = productDetails?.body.filter(
    (slice) => slice.type === 'instagram_posts'
  );

  return (
    <>
      {labeledIcons && (
        <SliceZone slices={labeledIcons} components={components} />
      )}
      {inspiration && (
        <SliceZone slices={inspiration} components={components} />
      )}
      {features && <SliceZone slices={features} components={components} />}
      {colorSample && (
        <SliceZone
          slices={colorSample}
          components={components}
          context={{ isMinimalist: isMinimalistType(product.productType.slug) }}
        />
      )}
      {saleorCategory && (
        <ProductReviews
          reviews={saleorCategory.reviews.edges.map(({ node }) => node)}
        />
      )}
      {details && <SliceZone slices={details} components={components} />}
      {instagramPosts && (
        <SliceZone slices={instagramPosts} components={components} />
      )}
      {saleorCategory && (
        <OtherProducts
          products={saleorCategory.products.edges
            .filter((e) => e.node.id !== product.id)
            .map(({ node }) => node)}
        />
      )}
    </>
  );
}
